"use strict";

const goBackBtn = document.getElementById('go-back');

if (goBackBtn) {
    goBackBtn.addEventListener('click', () => {
        history.back();
    });
}